module.exports = __webpack_public_path__ + "assets/img/activity-over.f337263e.png";